"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var container_styles_1 = __importDefault(require("../../_helpers/container-styles"));
var free_text_1 = __importDefault(require("../../_helpers/free-text"));
var root_props_1 = require("../../_helpers/root-props");
var styled_1 = __importStar(require("../../styled"));
var tokens_1 = require("../../tokens");
var icon_1 = __importDefault(require("../icon"));
var link_1 = __importStar(require("../link"));
var text_1 = __importDefault(require("../text"));
var ReadMoreLink = styled_1.default(link_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: underline;\n  &:hover {\n    text-decoration: none;\n  }\n  margin-left: ", ";\n"], ["\n  color: ", ";\n  text-decoration: underline;\n  &:hover {\n    text-decoration: none;\n  }\n  margin-left: ", ";\n"])), function (props) { return tokens_1.colors.alert[props.appearance].text; }, tokens_1.spacing.xxsmall);
var Alert = (function (_super) {
    __extends(Alert, _super);
    function Alert(props) {
        var _this = _super.call(this, props) || this;
        _this.dismiss = function () {
            _this.setState({ visible: false });
            if (typeof _this.props.onDismiss === 'function') {
                _this.props.onDismiss();
            }
        };
        _this.state = { visible: true };
        return _this;
    }
    Alert.prototype.componentDidMount = function () {
        if (this.props.dismissAfterSeconds) {
            this.timer = window.setTimeout(this.dismiss, this.props.dismissAfterSeconds * 1000);
        }
    };
    Alert.prototype.componentWillUnmount = function () {
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
    };
    Alert.prototype.render = function () {
        var appearance = this.props.appearance;
        if (this.state.visible) {
            return (React.createElement(Alert.Element, __assign({ appearance: appearance, dismissible: this.props.dismissible, "data-cosmos-appearance": appearance }, automation_attribute_1.default('alert'), root_props_1.rootProps(this.props)),
                this.props.icon && React.createElement(icon_1.default, { name: this.props.icon, color: iconColorMap[appearance] }),
                React.createElement("span", null,
                    React.createElement(text_1.default, { type: "strong" }, this.props.title),
                    " ",
                    React.createElement(free_text_1.default, __assign({}, this.props)),
                    this.props.link && (React.createElement(ReadMoreLink, { appearance: "default", href: this.props.link, target: "_blank" }, "Read more"))),
                this.props.dismissible && (React.createElement(Cross, __assign({ onClick: this.dismiss }, automation_attribute_1.default('alert.dismiss'))))));
        }
        else {
            return null;
        }
    };
    Alert.defaultProps = {
        appearance: 'default',
        dismissible: true,
    };
    return Alert;
}(React.Component));
var Cross = styled_1.default.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  font-size: 1.5em;\n  line-height: 1;\n  &:after {\n    content: '\u00D7';\n    font-weight: ", ";\n  }\n"], ["\n  cursor: pointer;\n  font-size: 1.5em;\n  line-height: 1;\n  &:after {\n    content: '\u00D7';\n    font-weight: ", ";\n  }\n"])), tokens_1.fonts.weight.bold);
var styledForCross = styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-right: ", ";\n"], ["\n  padding-right: ", ";\n"])), tokens_1.spacing.large);
Alert.Element = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  padding: ", " ", ";\n  ", ";\n\n  background-color: ", ";\n  color: ", ";\n  border-radius: 3px;\n  position: relative;\n  display: flex;\n  ", " {\n    margin-right: 12px;\n    position: relative;\n    top: 1px;\n    path {\n      fill: ", ";\n    }\n  }\n  ", " {\n    color: ", ";\n    text-decoration: underline;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n  ", " {\n    position: absolute;\n    right: 0;\n    top: 0;\n    color: ", ";\n    opacity: 0.3;\n    padding: ", " ", ";\n    &:hover {\n      opacity: 0.5;\n    }\n  }\n"], ["\n  ", ";\n  padding: ", " ", ";\n  ", ";\n\n  background-color: ", ";\n  color: ", ";\n  border-radius: 3px;\n  position: relative;\n  display: flex;\n  ", " {\n    margin-right: 12px;\n    position: relative;\n    top: 1px;\n    path {\n      fill: ", ";\n    }\n  }\n  ", " {\n    color: ", ";\n    text-decoration: underline;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n  ", " {\n    position: absolute;\n    right: 0;\n    top: 0;\n    color: ", ";\n    opacity: 0.3;\n    padding: ", " ", ";\n    &:hover {\n      opacity: 0.5;\n    }\n  }\n"])), container_styles_1.default, tokens_1.spacing.small, tokens_1.spacing.small, function (props) { return props.dismissible && styledForCross; }, function (props) { return tokens_1.colors.alert[props.appearance].background; }, function (props) { return tokens_1.colors.alert[props.appearance].text; }, icon_1.default.Element, function (props) { return tokens_1.colors.alert[props.appearance].text; }, link_1.StyledLink, function (props) { return tokens_1.colors.alert[props.appearance].text; }, Cross, function (props) { return tokens_1.colors.alert[props.appearance].text; }, tokens_1.spacing.small, tokens_1.spacing.small);
var iconColorMap = {
    default: 'default',
    information: 'blueDarker',
    success: 'greenDarker',
    warning: 'yellow',
    danger: 'redDarker',
};
exports.default = Alert;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=alert.js.map